import { getIdOrNull, isObject, requestMultipart, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'
import { Period } from '../timePeriods'

/** @enum {string} */
export const SerializationContexts = Object.freeze({
  LABELS: 'labels',
  SECTION: 'section',
  NAMES: 'names',
  INSTITUTION: 'institution'
})

/** @param {array<Quota>|Quota} quota */
export const createQuota = (user, quotas, headers) => {
  const body = isObject(quotas) ? quotas.toRequestBody() : quotas.map(q => q.toRequestBody())

  return apiClient.post(user, 'api/quotas', body, headers)
}

export const duplicateQuota = (user, quota) => apiClient.post(user, `api/quotas/${getIdOrNull(quota)}/duplicate`, quota.toRequestBody())

/** @param {Quota} quota */
export const updateQuota = (user, quota, headers) => apiClient.patch(user, `api/quotas/${getIdOrNull(quota)}`, quota.toRequestBody(), headers)
/** @param {Quota[]} quotas */
export const updateQuotas = (user, quotas, headers) => apiClient.patch(user, 'api/quotas', quotas, headers)

export const deleteQuota = (user, quota) => apiClient.delete(user, `api/quotas/${getIdOrNull(quota)}`)
/** @param {number[]} quotas */
export const deleteQuotas = (user, quotas) => apiClient.delete(user, 'api/quotas', { ids: quotas })

const DEFAULT_PERIOD = new Period().getDates()
export const getInternshipsQuotas = (user, internships, parameters = { period: DEFAULT_PERIOD, precision: 'year' }) => {
  const queryStringObject = {
    startDate: parameters.period.startDate,
    endDate: parameters.period.endDate,
    internships,
    precision: parameters.precision
  }

  return requestWithPromise(
    `/quota/internships${makeQueryString(queryStringObject)}`,
    HttpMethods.GET,
    null,
    user
  )
}

const DEFAULT_CONTEXTS = { contexts: [SerializationContexts.LABELS] }
export const getSectorQuotas = (user, sector, queryParams = DEFAULT_CONTEXTS) => apiClient.get(user, `api/sectors/${getIdOrNull(sector)}/quotas`, queryParams)

export const getAllQuotas = (user, parameters) => apiClient.get(user, 'api/quotas', parameters)

export const importQuotas = (user, institution, language, file, optionsToDisable = {}) => {
  return requestMultipart(
    `/import/institutions/${getIdOrNull(institution)}/quotas`,
    HttpMethods.POST,
    { ...optionsToDisable, file, language },
    user,
    true
  )
}

export const createQuotas = (user, body = []) => apiClient.post(user, 'api/quotas', body)

const DEFAULT_PARAM_TRESHOLD_PERIOD = { startDate: undefined, endDate: undefined }
export const getQuotaTreshold = (user, quota, parameters = DEFAULT_PARAM_TRESHOLD_PERIOD) => apiClient.get(user, `api/quotas/${getIdOrNull(quota)}/total-treshold`, parameters)
